!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports, require("leaflet")) : "function" == typeof define && define.amd ? define(["exports", "leaflet"], e) : e((t = "undefined" != typeof globalThis ? globalThis : t || self).LeafletLasso = {}, t.L);
}(this, function (t, e) {
  "use strict";
  /*! *****************************************************************************
      Copyright (c) Microsoft Corporation.
  
      Permission to use, copy, modify, and/or distribute this software for any
      purpose with or without fee is hereby granted.
  
      THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
      REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
      AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
      INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
      LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
      OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
      PERFORMANCE OF THIS SOFTWARE.
      ***************************************************************************** */

  var _o = function o(t, e) {
    return (_o = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var o in e) {
        Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
      }
    })(t, e);
  };

  function n(t, e) {
    function n() {
      this.constructor = t;
    }

    _o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
  }

  var _r = function r() {
    return (_r = Object.assign || function (t) {
      for (var e, o = 1, n = arguments.length; o < n; o++) {
        for (var r in e = arguments[o]) {
          Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }
      }

      return t;
    }).apply(this, arguments);
  };

  function i() {
    for (var t = 0, e = 0, o = arguments.length; e < o; e++) {
      t += arguments[e].length;
    }

    var n = Array(t),
        r = 0;

    for (e = 0; e < o; e++) {
      for (var i = arguments[e], s = 0, a = i.length; s < a; s++, r++) {
        n[r] = i[s];
      }
    }

    return n;
  }

  var s = function (t) {
    function o(o, n) {
      var i = t.call(this) || this;
      return i.polyline = e.polyline(o, n), i.polygon = e.polygon(o, _r(_r({}, n), {
        weight: 0
      })), i;
    }

    return n(o, t), o.prototype.onAdd = function (t) {
      return this.polyline.addTo(t), this.polygon.addTo(t), this;
    }, o.prototype.onRemove = function () {
      return this.polyline.remove(), this.polygon.remove(), this;
    }, o.prototype.addLatLng = function (t) {
      return this.polyline.addLatLng(t), this.polygon.addLatLng(t), this;
    }, o.prototype.getLatLngs = function () {
      return this.polygon.getLatLngs()[0];
    }, o.prototype.toGeoJSON = function () {
      return this.polygon.toGeoJSON();
    }, o;
  }(e.Layer),
      a = function a(t) {
    return !isNaN(parseFloat(t)) && isFinite(t);
  },
      l = function l(t, e, o, n) {
    var r = (n[0] - o[0]) * (t[1] - o[1]) - (n[1] - o[1]) * (t[0] - o[0]),
        i = (e[0] - t[0]) * (t[1] - o[1]) - (e[1] - t[1]) * (t[0] - o[0]),
        s = (n[1] - o[1]) * (e[0] - t[0]) - (n[0] - o[0]) * (e[1] - t[1]);

    if (0 !== s) {
      var a = r / s,
          l = i / s;
      if (a >= 0 && a <= 1 && l >= 0 && l <= 1) return !0;
    }

    return !1;
  },
      u = function t(e, o) {
    if (a(e[0][0])) {
      if (a(o[0][0])) {
        for (var n = 0; n < e.length - 1; n++) {
          for (var r = 0; r < o.length - 1; r++) {
            if (l(e[n], e[n + 1], o[r], o[r + 1])) return !0;
          }
        }
      } else for (var i = 0; i < o.length; i++) {
        if (t(e, o[i])) return !0;
      }
    } else for (var s = 0; s < e.length; s++) {
      if (t(e[s], o)) return !0;
    }

    return !1;
  },
      c = function c(t, e) {
    for (var o = !1, n = -1, r = t.length, i = r - 1; ++n < r; i = n) {
      (t[n][1] <= e[1] && e[1] < t[i][1] || t[i][1] <= e[1] && e[1] < t[n][1]) && e[0] < (t[i][0] - t[n][0]) * (e[1] - t[n][1]) / (t[i][1] - t[n][1]) + t[n][0] && (o = !o);
    }

    return o;
  },
      p = function p(t, e) {
    for (var o = 0; o < t.length; o++) {
      if (t[o] !== e[o]) return !1;
    }

    return !0;
  },
      d = function d(t, e) {
    return t[0] > e[0] ? -1 : t[0] < e[0] ? 1 : t[1] > e[1] ? -1 : t[1] < e[1] ? 1 : 0;
  },
      f = function f(t) {
    for (var e = [], o = 0; o < t.length; o++) {
      var n = t[o].slice();
      !1 === p(n[0], n[n.length - 1]) && n.push(n[0]), e.push(n);
    }

    return e;
  };
  /* @preserve
      * @terraformer/spatial - v2.0.6 - MIT
      * Copyright (c) 2012-2020 Environmental Systems Research Institute, Inc.
      * Mon May 18 2020 14:30:36 GMT-0700 (Pacific Daylight Time)
      */


  var h = function h(t, e) {
    if (t.length !== e.length) return !1;

    for (var o = t.slice().sort(d), n = e.slice().sort(d), r = 0; r < o.length; r++) {
      if (o[r].length !== n[r].length) return !1;

      for (var i = 0; i < o.length; i++) {
        if (o[r][i] !== n[r][i]) return !1;
      }
    }

    return !0;
  },
      g = function g(t) {
    for (var e = null, o = null, n = null, r = null, i = 0; i < t.length; i++) {
      for (var s = t[i], a = 0; a < s.length; a++) {
        var l = s[a],
            u = l[0],
            c = l[1];
        (null === e || u < e) && (e = u), (null === o || u > o) && (o = u), (null === n || c < n) && (n = c), (null === r || c > r) && (r = c);
      }
    }

    return [e, n, o, r];
  },
      y = function y(t) {
    for (var e = null, o = null, n = null, r = null, i = 0; i < t.length; i++) {
      var s = t[i],
          a = s[0],
          l = s[1];
      (null === e || a < e) && (e = a), (null === o || a > o) && (o = a), (null === n || l < n) && (n = l), (null === r || l > r) && (r = l);
    }

    return [e, n, o, r];
  },
      v = function v(t) {
    for (var e = [], o = t.features.length - 1; o >= 0; o--) {
      var n = M(t.features[o].geometry);
      e.push([n[0], n[1]]), e.push([n[2], n[3]]);
    }

    return y(e);
  },
      m = function m(t) {
    for (var e = [], o = t.geometries.length - 1; o >= 0; o--) {
      var n = M(t.geometries[o]);
      e.push([n[0], n[1]]), e.push([n[2], n[3]]);
    }

    return y(e);
  },
      M = function t(e) {
    if (e.type) switch (e.type) {
      case "Point":
        return [e.coordinates[0], e.coordinates[1], e.coordinates[0], e.coordinates[1]];

      case "MultiPoint":
      case "LineString":
        return y(e.coordinates);

      case "MultiLineString":
      case "Polygon":
        return g(e.coordinates);

      case "MultiPolygon":
        return function (t) {
          for (var e = null, o = null, n = null, r = null, i = 0; i < t.length; i++) {
            for (var s = t[i], a = 0; a < s.length; a++) {
              for (var l = s[a], u = 0; u < l.length; u++) {
                var c = l[u],
                    p = c[0],
                    d = c[1];
                (null === e || p < e) && (e = p), (null === o || p > o) && (o = p), (null === n || d < n) && (n = d), (null === r || d > r) && (r = d);
              }
            }
          }

          return [e, n, o, r];
        }(e.coordinates);

      case "Feature":
        return e.geometry ? t(e.geometry) : null;

      case "FeatureCollection":
        return v(e);

      case "GeometryCollection":
        return m(e);

      default:
        throw new Error("Unknown type: " + e.type);
    }
    return null;
  },
      L = function L(t, e) {
    if (t && t.length) {
      if (1 === t.length) return c(t[0], e);

      if (c(t[0], e)) {
        for (var o = 1; o < t.length; o++) {
          if (c(t[o], e)) return !1;
        }

        return !0;
      }

      return !1;
    }

    return !1;
  },
      A = function t(e, o) {
    var n, r, i;
    if ("Feature" === o.type && (o = o.geometry), "Point" === o.type && "Point" === e.type) return p(e.coordinates, o.coordinates);
    if ("MultiLineString" === o.type && "Point" === e.type) for (r = 0; r < e.coordinates.length; r++) {
      if (t(e, {
        type: "LineString",
        coordinates: o.coordinates[r]
      })) return !0;
    }
    if (("LineString" === o.type || "MultiPoint" === o.type) && "Point" === e.type) for (r = 0; r < o.coordinates.length; r++) {
      if (e.coordinates.length !== o.coordinates[r].length) return !1;
      if (p(e.coordinates, o.coordinates[r])) return !0;
    }

    if ("Polygon" === o.type) {
      if ("Polygon" === e.type) {
        if (o.coordinates.length === e.coordinates.length) for (r = 0; r < e.coordinates.length; r++) {
          if (h(e.coordinates[r], o.coordinates[r])) return !0;
        }
        return !(!e.coordinates.length || !L(o.coordinates, e.coordinates[0][0])) && !u(f(e.coordinates), f(o.coordinates));
      }

      if ("Point" === e.type) return L(o.coordinates, e.coordinates);

      if ("LineString" === e.type || "MultiPoint" === e.type) {
        if (!e.coordinates || 0 === e.coordinates.length) return !1;

        for (r = 0; r < e.coordinates.length; r++) {
          if (!1 === L(o.coordinates, e.coordinates[r])) return !1;
        }

        return !0;
      }

      if ("MultiLineString" === e.type) {
        for (r = 0; r < e.coordinates.length; r++) {
          if (!1 === t({
            type: "LineString",
            coordinates: e.coordinates[r]
          }, o)) return i++, !1;
        }

        return !0;
      }

      if ("MultiPolygon" === e.type) {
        for (r = 0; r < e.coordinates.length; r++) {
          if (!1 === t({
            type: "Polygon",
            coordinates: e.coordinates[r]
          }, o)) return !1;
        }

        return !0;
      }
    }

    if ("MultiPolygon" === o.type) {
      if ("Point" === e.type) {
        if (o.coordinates.length) for (r = 0; r < o.coordinates.length; r++) {
          if (n = o.coordinates[r], L(n, e.coordinates) && !1 === u([e.coordinates], o.coordinates)) return !0;
        }
        return !1;
      }

      if ("Polygon" === e.type) {
        for (r = 0; r < e.coordinates.length; r++) {
          if (o.coordinates[r].length === e.coordinates.length) for (var s = 0; s < e.coordinates.length; s++) {
            if (h(e.coordinates[s], o.coordinates[r][s])) return !0;
          }
        }

        if (!1 === u(e.coordinates, o.coordinates) && o.coordinates.length) {
          for (r = 0; r < o.coordinates.length; r++) {
            n = o.coordinates[r], i = !1 !== L(n, e.coordinates[0][0]);
          }

          return i;
        }
      } else if ("LineString" === e.type || "MultiPoint" === e.type) for (r = 0; r < o.coordinates.length; r++) {
        return !!t(e, {
          type: "Polygon",
          coordinates: o.coordinates[r]
        });
      } else {
        if ("MultiLineString" === e.type) {
          for (r = 0; r < e.coordinates.length; r++) {
            if (!1 === t({
              type: "LineString",
              coordinates: e.coordinates[r]
            }, o)) return !1;
          }

          return !0;
        }

        if ("MultiPolygon" === e.type) {
          for (r = 0; r < o.coordinates.length; r++) {
            if (!1 === t(e, {
              type: "Polygon",
              coordinates: o.coordinates[r]
            })) return !1;
          }

          return !0;
        }
      }
    }

    return !1;
  },
      b = function b(t, e) {
    return A(e, t);
  },
      E = function t(e, o) {
    return "Feature" === o.type && (o = o.geometry), !(!A(e, o) && !A(o, e)) || ("Point" !== e.type && "MultiPoint" !== e.type && "Point" !== o.type && "MultiPoint" !== o.type ? u(e.coordinates, o.coordinates) : "Feature" === e.type ? t(e.geometry, o) : (function () {
      var t = Array.prototype.slice.apply(arguments);
      "undefined" != typeof console && console.warn && console.warn.apply(console, t);
    }("Type " + e.type + " to " + o.type + " intersection is not supported by intersects"), !1));
  },
      P = 6378137,
      S = 6356752.3142,
      D = 1 / 298.257223563,
      w = function w(t, e, o) {
    for (var n, r = o || 64, i = {
      type: "Polygon",
      coordinates: [[]]
    }, s = 0; s < r; s++) {
      n = 360 * s / r, i.coordinates[0].push(C(t, n, e));
    }

    return i.coordinates = f(i.coordinates), i;
  },
      C = function C(t, e, o) {
    for (var n, r, i, s = P, a = S, l = D, u = t[0], c = t[1], p = o, d = Math.PI, f = e * d / 180, h = Math.sin(f), g = Math.cos(f), y = (1 - l) * Math.tan(c * d / 180), v = 1 / Math.sqrt(1 + y * y), m = y * v, M = Math.atan2(y, g), L = v * h, A = 1 - L * L, b = A * (s * s - a * a) / (a * a), E = 1 + b / 16384 * (4096 + b * (b * (320 - 175 * b) - 768)), w = b / 1024 * (256 + b * (b * (74 - 47 * b) - 128)), C = p / (a * E), B = 2 * Math.PI; Math.abs(C - B) > 1e-12;) {
      n = Math.cos(2 * M + C), B = C, C = p / (a * E) + w * (r = Math.sin(C)) * (n + w / 4 * ((i = Math.cos(C)) * (2 * n * n - 1) - w / 6 * n * (4 * r * r - 3) * (4 * n * n - 3)));
    }

    var T = m * r - v * i * g,
        I = Math.atan2(m * i + v * r * g, (1 - l) * Math.sqrt(L * L + T * T)),
        U = l / 16 * A * (4 + l * (4 - 3 * A));
    return [u + 180 * (Math.atan2(r * h, v * i - m * r * g) - (1 - U) * l * L * (C + U * r * (n + U * i * (2 * n * n - 1)))) / d, 180 * I / d];
  };

  function B(t, o) {
    return function (t, e, o) {
      var n = o || 64,
          r = e || 250;
      if (!t || t.length < 2 || !r || !n) throw new Error("Terraformer: missing parameter for Terraformer.Circle");
      return {
        type: "Feature",
        geometry: w(t, r, n),
        properties: {
          radius: r,
          center: t,
          steps: n
        }
      };
    }(e.GeoJSON.latLngToCoords(t), o).geometry;
  }

  function T(t, o) {
    return void 0 === o && (o = {}), t instanceof e.Circle ? B(t.getLatLng(), t.getRadius()) : t instanceof e.CircleMarker ? null != o.zoom && null != o.crs ? B(t.getLatLng(), function (t, o, n) {
      var r = t.getLatLng(),
          i = o.latLngToPoint(r, n),
          s = t.getRadius() / Math.SQRT2,
          a = e.point([i.x - s, i.y - s]),
          l = o.pointToLatLng(a, n);
      return o.distance(r, l);
    }(t, o.crs, o.zoom)) : (console.warn("Zoom and CRS is required for calculating CircleMarker polygon, falling back to center point only"), t.toGeoJSON().geometry) : t instanceof e.Marker || t instanceof e.Polyline ? t.toGeoJSON().geometry : void 0;
  }

  function I(t, o, n) {
    void 0 === n && (n = {});
    var r = t.toGeoJSON().geometry,
        i = t.getBounds();
    return o.filter(function (t) {
      var o, s, a;
      return t instanceof e.Polyline ? s = t.getBounds() : (o = T(t, n), a = M(o), s = e.latLngBounds([a[1], a[0]], [a[3], a[2]])), !!(n.intersect ? i.intersects(s) : i.contains(s)) && (o || (o = T(t, n)), n.intersect ? function (t, e) {
        return "Point" === e.type ? b(t, e) : E(t, e);
      }(r, o) : function (t, e) {
        return b(t, e);
      }(r, o));
    });
  }

  function U(t, e) {
    void 0 === e && (e = {});
    var o = e.insertAt;

    if (t && "undefined" != typeof document) {
      var n = document.head || document.getElementsByTagName("head")[0],
          r = document.createElement("style");
      r.type = "text/css", "top" === o && n.firstChild ? n.insertBefore(r, n.firstChild) : n.appendChild(r), r.styleSheet ? r.styleSheet.cssText = t : r.appendChild(document.createTextNode(t));
    }
  }

  U(".leaflet-lasso-active {\n    cursor: crosshair;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.leaflet-lasso-active .leaflet-interactive {\n    cursor: crosshair;\n    pointer-events: none;\n}");

  var O = "leaflet-lasso-active",
      k = function (t) {
    function o(o, n) {
      void 0 === n && (n = {});
      var r = t.call(this, o) || this;
      return r.options = {
        polygon: {
          color: "#00C3FF",
          weight: 2
        },
        intersect: !1
      }, r.onMapMouseDownBound = r.onMapMouseDown.bind(r), r.onDocumentMouseMoveBound = r.onDocumentMouseMove.bind(r), r.onDocumentMouseUpBound = r.onDocumentMouseUp.bind(r), r.map = o, e.Util.setOptions(r, n), r;
    }

    return n(o, t), o.prototype.setOptions = function (t) {
      this.options = _r(_r({}, this.options), t);
    }, o.prototype.toggle = function () {
      this.enabled() ? this.disable() : this.enable();
    }, o.prototype.addHooks = function () {
      this.map.getPane("mapPane"), this.map.getContainer().addEventListener("mousedown", this.onMapMouseDownBound), this.map.getContainer().addEventListener("touchstart", this.onMapMouseDownBound), this.map.getContainer().classList.add(O), this.map.dragging.disable(), this.map.fire("lasso.enabled");
    }, o.prototype.removeHooks = function () {
      this.polygon && (this.map.removeLayer(this.polygon), this.polygon = void 0), this.map.getContainer().removeEventListener("mousedown", this.onMapMouseDownBound), this.map.getContainer().removeEventListener("touchstart", this.onMapMouseDownBound), document.removeEventListener("mousemove", this.onDocumentMouseMoveBound), document.removeEventListener("touchmove", this.onDocumentMouseMoveBound), document.removeEventListener("mouseup", this.onDocumentMouseUpBound), document.removeEventListener("touchend", this.onDocumentMouseUpBound), this.map.getContainer().classList.remove(O), document.body.classList.remove(O), this.map.dragging.enable(), this.map.fire("lasso.disabled");
    }, o.prototype.onMapMouseDown = function (t) {
      var e = this.eventToMouseEvent("down", t);
      if (e) if (t instanceof MouseEvent && 1 !== t.buttons) this.disable();else if (!t.target.closest(".leaflet-control-container")) {
        var o = this.map.mouseEventToLatLng(e);
        this.polygon = new s([o], this.options.polygon).addTo(this.map), document.body.classList.add(O), document.addEventListener("mousemove", this.onDocumentMouseMoveBound), document.addEventListener("touchmove", this.onDocumentMouseMoveBound), document.addEventListener("mouseup", this.onDocumentMouseUpBound), document.addEventListener("touchend", this.onDocumentMouseUpBound), t.preventDefault();
      }
    }, o.prototype.onDocumentMouseMove = function (t) {
      var e = this.eventToMouseEvent("move", t);

      if (e && this.polygon) {
        if (t instanceof MouseEvent && 1 !== t.buttons) return console.warn("mouseup event was missed"), void this.finish();
        var o = this.map.mouseEventToLatLng(e);
        this.polygon.addLatLng(o), t.preventDefault();
      }
    }, o.prototype.onDocumentMouseUp = function (t) {
      this.finish(), t.preventDefault();
    }, o.prototype.eventToMouseEvent = function (t, e) {
      return e instanceof MouseEvent ? e : e instanceof TouchEvent && 1 === e.touches.length ? new MouseEvent(t, {
        screenX: e.touches[0].screenX,
        screenY: e.touches[0].screenY,
        clientX: e.touches[0].clientX,
        clientY: e.touches[0].clientY,
        buttons: 1
      }) : void 0;
    }, o.prototype.finish = function () {
      var t = this;

      if (this.polygon) {
        var o = [];
        this.map.eachLayer(function (n) {
          n !== t.polygon && n !== t.polygon.polyline && n !== t.polygon.polygon && (e.MarkerCluster && n instanceof e.MarkerCluster ? o.push.apply(o, n.getAllChildMarkers()) : (n instanceof e.Marker || n instanceof e.Path) && o.push(n));
        });
        var n = I(this.polygon.polygon, o, {
          zoom: this.map.getZoom(),
          crs: this.map.options.crs,
          intersect: this.options.intersect
        });
        this.map.fire("lasso.finished", {
          latLngs: this.polygon.getLatLngs(),
          layers: n
        }), this.disable();
      }
    }, o;
  }(e.Handler);

  U(".leaflet-control-lasso {\n    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsSAAALEgHS3X78AAAD6UlEQVR4nO1b7XHbMAwFfP0fdYKqE8QbRJ0gGUEjaAR3A4/gbuBOUHWCKhs4E1SegD06jzmYpWhJpiRKNu58Tix+AA8gCQIQK6Xolml109LfAbgDcAfg5gH4NPQEzJwSkf4kRLR2NKmJqNLfSqlqaH7+4y/0McjML0SUQdinHkO8ApCSiPZKqToogxYFAQBC50T03NDkN74raFzSGtahreSLo+9PALG7mlEXaQD6fMD0BgIp8TkQ0ZaINChpl7ExZoZxK2vcGr8nfXl2ztm5g1twI/Q6KHPvVlFg/DMgJgEAWpWCay3lIYX2zJ1bQFQhAO+i9b2l8VEEd/BSWEooBgUAm5REPvg67AGCrZDdIABgQ6qF1oOu8QBAbK4FwTd4bq23SbXeks/OIPg0f7V5TQRCpz3BNdhamH30wgu+CwFC66VqD5IIByRas/eAYDbGqi8AW+FszEp4ocC6y1KQneW6z+YmvJDDLIVDVwBKdNzPVXghi/FbLjprp4AIM2fi6loMcusal8zN8eXirOp885jNrn/BAlKxnL17GWPj+As8viqlDguwAG3V+hR7JKJvSqmyqd1KmMnrUoQHGaEzX6OVaLAfg6sRyUSeUt+UKxGobDSTmZKR5yIAj/h79IhsDPSRFxg6+ho9AAukpI1IgydGxiY4dSRON+/SXgwAyE1sHbkF79JmeEuaPs91H4DWf+Ffk1nSgDwQ0RH5iUbZqgXcAI0MG/FbKn7f+i5DZo14PabISR/lb0qpjWETXq252LmSsidaCYfh8s0pbnKZuFHuEzNvmNl5MiR9YmmRLYHaxb8VJ3SG+UzD3ZyvwyI/UEPozMoZFE2xTjOADId1yuhGBMLO0raSUSE74HsGgDoPiZULsIISPkFqtUlEuOx0YsiHadeIakTC57bGPW0zAVRiP+yVXJhY+M6JHLFcCtfDvUAoahCseoXW0Wz0Oy1310O5WUQLgmX2ZddEzkffhoc2CJMUQ3h4kzt+v7S4ke/CRKWYaBtBYURmF2tcMda7bC0absWEk5TG4ISyS3Suury1BqAB+XIMIDCv7eAEsUTvHtDQoak8bhPSexSlcXadYBlqHu8p0BMIZRVIti9QeD/Hc/S1hVawgKDuufQDriqVZeYcAjeVyL4BGBc1lcaSKY8dolaYmTXgf0ykKFStcCIKpM33Q8vuR1EcXeEuMkhoDnyWCKB81wGUQV+aEhFaJ/mSlgPwYvyHZ8QN9SlS38RbY3hnYQ/NHyH8KVq0+DdGdCgMS+sRe1ImX8xYvAUw8wGb7Q9c88/2l1sAIEPBlPM0ur85GgEPk9IdgAh4mJTuAETAw3RERP8Ab2Uzgrad13wAAAAASUVORK5CYII=');\n    background-size: 22px;\n}");

  var R = function (t) {
    function o(o) {
      void 0 === o && (o = {});
      var n = t.call(this) || this;
      return n.options = {
        position: "topright"
      }, e.Util.setOptions(n, o), n;
    }

    return n(o, t), o.prototype.setOptions = function (t) {
      this.options = _r(_r({}, this.options), t), this.lasso && this.lasso.setOptions(this.options);
    }, o.prototype.onAdd = function (t) {
      this.lasso = new k(t, this.options);
      var o = e.DomUtil.create("div", "leaflet-bar leaflet-control"),
          n = e.DomUtil.create("a", "leaflet-control-lasso", o);
      return n.href = "#", n.title = "Toggle Lasso", n.setAttribute("role", "button"), n.setAttribute("aria-label", n.title), e.DomEvent.addListener(n, "click", this.toggle, this), e.DomEvent.disableClickPropagation(n), o;
    }, o.prototype.enabled = function () {
      return !!this.lasso && this.lasso.enabled();
    }, o.prototype.enable = function () {
      this.lasso && this.lasso.enable();
    }, o.prototype.disable = function () {
      this.lasso && this.lasso.disable();
    }, o.prototype.toggle = function () {
      this.lasso && this.lasso.toggle();
    }, o;
  }(e.Control);

  void 0 !== window.L && (window.L.Lasso = k, window.L.lasso = function () {
    for (var t = [], e = 0; e < arguments.length; e++) {
      t[e] = arguments[e];
    }

    return new (k.bind.apply(k, i([void 0], t)))();
  }, window.L.Control.Lasso = R, window.L.control.lasso = function () {
    for (var t = [], e = 0; e < arguments.length; e++) {
      t[e] = arguments[e];
    }

    return new (R.bind.apply(R, i([void 0], t)))();
  }), t.ACTIVE_CLASS = O, t.DISABLED_EVENT = "lasso.disabled", t.ENABLED_EVENT = "lasso.enabled", t.FINISHED_EVENT = "lasso.finished", t.LassoControl = R, t.LassoHandler = k, Object.defineProperty(t, "__esModule", {
    value: !0
  });
});